import { Box, Typography } from '@mui/material';
import React from 'react';
import CustomAvatar from '../CustomAvatar/CustomAvatar';
import { COLORS } from '../../constants/constants';

export interface ProfileInfoProps {
    imageSrc: string;
    platform?: string;
    avatarSize?: string;
    smallAvatarSize?: string;
    topInfo?: React.ReactNode;
    bottomInfo?: React.ReactNode;
    bottomInfoStyles?: object;
    styles?: Object;
    avatarStyles?: Object;
}

const ProfileInfo: React.FC<ProfileInfoProps> = ({
    imageSrc,
    platform,
    topInfo,
    bottomInfo,
    styles,
    avatarSize,
    smallAvatarSize,
    bottomInfoStyles,
    avatarStyles,
}) => {
    const displayInfo = (top, info: React.ReactNode, styles?: Object) => {
        const typographySx = styles ? { maxWidth: '250px', ...styles } : { display: 'flex' };
        return typeof info === 'string' ? (
            <Typography
                className="color-mh"
                variant={top ? 's16w500' : 'body1'}
                title={info.toString()}
                noWrap
                sx={typographySx}
            >
                {info}
            </Typography>
        ) : (
            info
        );
    };

    return (
        <Box sx={{ display: 'flex', ...styles }} data-testid="profile-information">
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                }}
            >
                <CustomAvatar
                    avatar={{ source: platform?.toUpperCase(), imgSrc: imageSrc }}
                    avatarStyles={avatarStyles || {}}
                    avatarSize={avatarSize}
                    smallAvatarSize={smallAvatarSize || '20px'}
                />
                {(topInfo || bottomInfo) && (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            ml: 2,
                            width: '100%',
                        }}
                    >
                        <Box>{displayInfo(true, topInfo)}</Box>
                        <Box sx={{ mt: 0.5, ...bottomInfoStyles }}>
                            {displayInfo(false, bottomInfo, {
                                fontSize: '14px',
                                color: COLORS.MUTED_SHADY,
                            })}
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ProfileInfo;
